import React from 'react'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import Hero from '../../organisms/Hero'
import { HeroBannerSliceProps } from './types'
import { mapButtonProps } from '../../atoms/Button/utils'

const HeroBannerSlice: React.FC<HeroBannerSliceProps> = ({ slice }) => {
  const {
    hb_title,
    hb_is_main_heading,
    hb_description,
    hb_button_text,
    hb_button_caption,
    hb_button_caption_mobile_size,
    hb_button_caption_desktop_size,
    hb_button_link,
    hb_button_type,
    hb_button_is_centered,
    hb_image,
    hb_video
  } = slice.primary || {}

  const { group } = usePageContext()

  return (
    <Hero
      data={{
        withGradientBg: false,
        icon: '',
        title: hb_title?.text,
        isMainHeading: hb_is_main_heading,
        subtitle: ``,
        desc: '',
        caption: hb_description?.html,
        cta: mapButtonProps(
          hb_button_type,
          hb_button_text,
          resolvePrismicLink(hb_button_link, group),
          hb_button_link?.link_type,
          hb_button_caption,
          hb_button_caption_mobile_size,
          hb_button_caption_desktop_size,
          hb_button_is_centered
        ),
        media: {
          image: {
            publicURL: hb_image?.url,
            childImageSharp: hb_image && {
              gatsbyImageData: hb_image.gatsbyImageData
            },
            width: hb_image?.dimensions?.width,
            height: hb_image?.dimensions?.height,
            alt: hb_image?.alt
          },
          video: {
            url: hb_video?.url
          }
        }
      }}
      paddingBottom={['84px', '', '172px']}
      paddingTop={['108px', '', '172px']}
      isReversed
    />
  )
}

export default HeroBannerSlice
